import React, { Component, ReactElement, ReactPortal } from "react";
import { AnyAction, bindActionCreators, Dispatch } from "redux";
import { connect } from "react-redux";
import { logoutFromTnAccount } from "../app/store/auth/actions";

type Props = {
  children: ReactElement | string | ReactPortal;
};

type LogoutFromTnAccountContainerProps = ReturnType<typeof mapDispatchToProps> & Props;

class LogoutFromTnAccountContainer extends Component<LogoutFromTnAccountContainerProps, {}> {

  handleLogout(): void {
    this.props.logoutFromTnAccount();
  }

  render() {
    return (
      <span onClick={this.handleLogout.bind(this)}>
        { this.props.children }
      </span>
    );
  }

}

const mapDispatchToProps = (dispatch: Dispatch<AnyAction>) => bindActionCreators(
  {
    logoutFromTnAccount
  }, dispatch
);

export default connect(
  null,
  mapDispatchToProps,
)(LogoutFromTnAccountContainer);
